<template>
    <div id="simple-calendar-app">
        <div class="vx-card no-scroll-content" style="min-height: 800px">
            <calendar-view
                    ref="calendar"
                    :displayPeriodUom="calendarView"
                    :show-date="showDate"
                    :events="calendarEvents"
                    :displayPeriodCount="2"
                    :startingDayOfWeek="1"
                    :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
                    eventBorderHeight="0px"
                    @click-event="openUser"
                    eventContentHeight="1.65rem"
                    class="theme-default">

                <div slot="header" class="mb-4">

                    <div class="vx-row no-gutter">

                        <!-- Current Month -->
                        <div class="vx-col w-1/2 sm:my-0 my-3 flex sm:justify-end justify-end order-last">
                            <div class="flex items-center">
                                <feather-icon
                                        :icon="'ChevronLeftIcon'"
                                        @click="updateMonth(-1)"
                                        svgClasses="w-5 h-5 m-1"
                                        class="cursor-pointer bg-primary text-white rounded-full" />

                                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                                <feather-icon
                                        :icon="'ChevronRightIcon'"
                                        @click="updateMonth(1)"
                                        svgClasses="w-5 h-5 m-1"
                                        class="cursor-pointer bg-primary text-white rounded-full" />
                            </div>
                        </div>

                        <div class="vx-col w-1/2 flex justify-start">
                            <template v-for="(view, index) in calendarViewTypes">
                                <vs-button
                                        v-if="calendarView === view.val"
                                        :key="String(view.val) + 'filled'"
                                        type="filled"
                                        class="p-3 md:px-8 md:py-3"
                                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                        @click="calendarView = view.val"
                                >{{ view.label }}</vs-button>
                                <vs-button
                                        v-else
                                        :key="String(view.val) + 'border'"
                                        type="border"
                                        class="p-3 md:px-8 md:py-3"
                                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                        @click="calendarView = view.val"
                                >{{ view.label }}</vs-button>
                            </template>

                        </div>
                    </div>

                    <div class="vx-row sm:flex mt-6">
                        <div class="vx-col w-full flex">
                            <div class="flex flex-wrap sm:justify-start justify-start">
                                <div v-for="(label, index) in labels" :key="index" class="flex items-center mr-4 mb-2">
                                    <div class="h-3 w-3 inline-block rounded-full mr-2" v-bind:style="{background: label.color}" ></div>
                                    <span>{{ label.text }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </calendar-view>
        </div>
    </div>
</template>
<script>

    import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
    require("vue-simple-calendar/static/css/default.css");
    import { en, he } from "vuejs-datepicker/src/locale"


    export default {
        components: {
            CalendarView,
            CalendarViewHeader,
        },
        data() {
            return {
                absencesRaw: undefined,
                showDate: new Date(),
                calendarView: 'week',

                calendarViewTypes: [
                    {
                        label: this.$t("Month"),
                        val: "month"
                    },
                    {
                        label: this.$t("Week"),
                        val: "week"
                    },
                ],

                labels: [
                    { text: this.$t('VacationDays'), color: '#4834d4' },
                    { text: this.$t('SickLeaves'), color: '#34495e'},
                    { text: this.$t('ParentalLeaves'), color: '#3498db'},
                    { text: this.$t('BusinessTrips'), color: '#e74c3c'},
                    { text: this.$t('PlannedAbsence'), color: '#27ae60'},
                ],
            }
        },
        methods: {
            updateAbsences() {
                const thisIns = this;
                this.$http.get('/api/v1/calendar/absences')
                   .then(function (response) {
                       thisIns.absencesRaw = response.data

                   })
                   .catch(function (error) {
                       thisIns.$vs.notify({
                           title:'Error',
                           text: error,
                           position:'top-right',
                           color:'danger',
                           iconPack: 'feather',
                           icon:'icon-alert-circle'})
                   });


            },
            updateMonth(val) {
                this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
            },
            typeToClass(val){
                switch (val) {
                    case 0: return "event-absence";
                    case 1: return "event-vacation";
                    case 2: return "event-sick-leave";
                    case 3: return "event-business-trip";
                    case 4: return "event-parental-leave";

                }
            },
            openUser(date){
                this.$router.push({ name: 'user', params: { id: "" + this.absencesRaw[date.id].user_id } })
            }
        },
        computed: {
            windowWidth() {
                return this.$store.state.windowWidth
            },
            calendarEvents() {

                let events = [];

                if(this.absencesRaw) {

                    for(let x = 0; x < this.absencesRaw.length; x++) {
                        events.push({
                            id: x,
                            startDate: this.moment(this.absencesRaw[x].start).format("YYYY-MM-DD"),
                            endDate: this.moment(this.absencesRaw[x].end).format("YYYY-MM-DD"),
                            title: this.absencesRaw[x].user,
                            classes: this.typeToClass(this.absencesRaw[x].type),
                        });
                    }

                }

                return events
            },
        },
        created() {
            this.updateAbsences();
        }

    }

</script>
<style lang="scss">
    @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
